import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";
import {TableSort} from "../interfaces/table/table-sort";

@Injectable({
  providedIn: 'root'
})
export class ServiceScheduleService {
  private readonly apiService = inject(BaseApiService);

  async getServiceSchedules(
    limit: number,
    offset: number,
    search: string,
    order: TableSort | null,
    locationId: string,
    isUpcoming: boolean
  ) {
    const body = {
      Offset: offset,
      Limit: limit,
      Sort: JSON.stringify(order),
      Search: search,
      LocationId: locationId == '0' || !locationId ? null : locationId,
      IsUpcoming: isUpcoming
    };
    return await this.apiService.post('/service-schedule', body);
  }
}
